import React, { useCallback, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setSuperTracks } from "@/store/supertrackSlice";
import { matchApi } from "@/api";
import { toast } from "react-toastify";

export function SuperTrackMarkupPlayerSelect({
  superTrack,
  jerseys,
  isDuplicate,
}) {
  const { videoId } = useParams();
  const dispatch = useDispatch();
  const [jersey, setJersey] = useState(superTrack.jersey);
  const { superTracks, teams, match } = useSelector(
    ({ superTracks }) => superTracks
  );
  // const [filteredPlayers, setFilteredPlayers] = useState([]);

  // const teams = useSelector(({ superTracks }) => superTracks.teams);
  // const playersMap = useSelector(({ superTracks }) => superTracks.playersMap);
  // const storedData = JSON.parse(localStorage.getItem('superTrackTeams')) || {};
  const onSuperTrackUpdate = useCallback(
    async (data) => {
      //     storedData[superTrack.id] = data.team;

      // localStorage.setItem('superTrackTeams', JSON.stringify(storedData));
      const { kind } = data;
      if (superTrack.kind === kind) {
        return;
      }

      if (teams.ball?.length > 0 && kind === "ball") {
        toast.warning("You are allowed to pick only one ball track.");
        return;
      }

      const updatedSuperTrack = { ...superTrack, ...data };
      dispatch(
        setSuperTracks({ ...superTracks, [superTrack.id]: updatedSuperTrack })
      );

      if (kind) {
        await matchApi.postSuperTrackPlayer({
          matchId: videoId,
          superTracksId: superTrack.id,
          kind,
        });
      }
    },
    [dispatch, superTrack, superTracks, videoId]
  );

  const onJerseyUpdate = useCallback(
    async (data) => {
      const { jersey } = data;
      if (superTrack.jersey === jersey) {
        return;
      }

      const updatedSuperTrack = { ...superTrack, ...data };
      dispatch(
        setSuperTracks({ ...superTracks, [superTrack.id]: updatedSuperTrack })
      );

      if (jersey !== undefined) {
        await matchApi.postSuperTrackJersey({
          matchId: videoId,
          superTracksId: superTrack.id,
          jersey,
        });
      }
    },
    [dispatch, superTrack, superTracks, videoId]
  );

  // useEffect(() => {
  //   if (!superTrack.team) return;
  //   const filtered = playersMap.get(Number(superTrack.team)) ?? [];
  //   setFilteredPlayers(filtered);
  // }, [superTrack.team, playersMap, superTrack.id, onSuperTrackUpdate]);

  return (
    <InputGroup size="sm" style={{ maxHeight: 24 }}>
      <div
        className="tw-mr-1 tw-w-4 tw-h-full"
        style={{
          backgroundColor: (() => {
            if (superTrack.kind === "left_team") {
              if (match.left_team_jersey_color) {
                return match.left_team_jersey_color === "deep_blue"
                  ? "#19295e"
                  : match.left_team_jersey_color;
              }
              return "#6b7280"; // Default gray if no color found
            }

            if (superTrack.kind === "right_team") {
              if (match.right_team_jersey_color) {
                return match.right_team_jersey_color === "deep_blue"
                  ? "#19295e"
                  : match.right_team_jersey_color;
              }
              return "#6b7280"; // Default gray if no color found
            }

            return "#6b7280"; // Default gray for no team selected
          })(),
        }}
      ></div>
      <Form.Select
        value={superTrack.kind ?? ""}
        onChange={(event) =>
          onSuperTrackUpdate({
            kind: event.target.value,
          })
        }
        style={{
          height: 24,
          paddingTop: "0px",
          paddingBottom: "0px",
          color: isDuplicate ? "red" : "black",
        }}
      >
        <option value="">Select Type</option>
        <option value="left_team">Left Team</option>
        <option value="right_team">Right Team</option>
        <option value="ball">Ball</option>
      </Form.Select>
      <Form.Control
        type="text"
        placeholder="Jersey #"
        value={jersey ?? ""}
        onChange={(event) => setJersey(event.target.value)}
        onBlur={(event) =>
          onJerseyUpdate({
            jersey: event.target.value || null,
          })
        }
        style={{
          height: 24,
          paddingTop: "0px",
          paddingBottom: "0px",
          maxWidth: 80,
          color: isDuplicate ? "red" : "black",
        }}
      />
    </InputGroup>
  );
}
